import { render, staticRenderFns } from "./choseQuestion.vue?vue&type=template&id=00dc3f64&"
import script from "./choseQuestion.vue?vue&type=script&lang=js&"
export * from "./choseQuestion.vue?vue&type=script&lang=js&"
import style0 from "./choseQuestion.vue?vue&type=style&index=0&id=00dc3f64&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports